import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    if (password !== confirm) return toast.error("Passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated - sign in with your new password.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-6 animate-slide-up" data-testid="reset-password-form">
      <div className="flex flex-col items-start gap-3 mb-6">
        <LockKeyhole className="text-race-red" size={32} />
        <h1 className="font-heading text-5xl tracking-tight">SET A NEW PASSWORD</h1>
        <p className="text-race-sub text-sm">Choose a new password for your Text Racing account.</p>
      </div>
      <form onSubmit={submit} className="bg-race-surface border border-race-line p-6 flex flex-col gap-4">
        <div>
          <label className="overline block mb-1">New Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password"
            className="w-full bg-race-bg border border-race-line focus:border-race-red outline-none px-3 py-2.5 rounded-sm text-race-txt" />
        </div>
        <div>
          <label className="overline block mb-1">Confirm Password</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm"
            className="w-full bg-race-bg border border-race-line focus:border-race-red outline-none px-3 py-2.5 rounded-sm text-race-txt" />
        </div>
        <button type="submit" disabled={busy} data-testid="reset-submit"
          className="bg-race-red hover:bg-race-redhover disabled:opacity-50 text-race-bg font-heading text-2xl tracking-wide py-3 rounded-sm transition-colors">
          {busy ? "…" : "UPDATE PASSWORD"}
        </button>
      </form>
      <p className="text-center text-sm text-race-sub mt-4">
        <Link to="/login" className="text-race-red hover:underline" data-testid="reset-switch-login">Back to sign in</Link>
      </p>
    </div>
  );
}
